/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Upload/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import CameraAction from './CameraAction/index'
import ImagePreview from './ImagePreview/index'
import React from 'react'
import UploadButton from './UploadButton/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Upload({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Picture/Upload"
  
}) {
  let isBefore = useIsBefore()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Upload.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ImagePreview
  viewPath={`${viewPath}/ImagePreview`}
/>
<div
  data-testid="Upload.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-1-Z24IIhc': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<input
 type="file"
  data-testid="Upload.Capture"
  data-view-path={viewPath}
 accept=".jpg,.jpeg,.png,/image*"
 onChange={(e) => onChange && onChange(e, e.target.value)}
 className={`views-capture ${styles.Capture}`}
/>
<UploadButton
  viewPath={`${viewPath}/UploadButton`}
/>
</div>
<CameraAction
  viewPath={`${viewPath}/CameraAction`}
/>
</div>
{children}
</React.Fragment>)
}